module.exports = __webpack_public_path__ + "img/project-5.ecffa191.jpg";